import { AuditDetailCardController } from './audit-detail-card.controller'

function auditDetailCard () {
  return {
    restrict: 'E',
    scope: {
      audit: '<',
      analyticsAdvancedBoards: '<'
    },
    templateUrl: '/audit/directives/audit-detail-card/audit-detail-card-directive.html?$$REVISION$$',
    controller: AuditDetailCardController
  }
}

export { auditDetailCard }
